import { Injectable, isDevMode } from "@angular/core";
import { Response, Http } from "@angular/http";
import { environment } from "../../../../environments/environment";
import { HttpInterceptor } from "../services/http-error.interceptor";

@Injectable()
export class Globals {
  public domain: string;
  public url: string;
  public languages: any[];
  public apiVersion: string;
  public frontendRefresh: boolean;

  constructor(private http: Http) {
    this.url = "../api/v3/";
    this.frontendRefresh = false;
    this.domain = "c3cloudcontrol.com";
    this.languages = [
      { id: 1, lang: "Portuguese" },
      { id: 2, lang: "Brazilian Portuguese" },
      { id: 3, lang: "English" },
      { id: 4, lang: "Spanish" },
      { id: 5, lang: "French" },
      { id: 6, lang: "Arabic" },
      { id: 100, lang: "Other" },
    ];
    if (!this.apiVersion) {
      this.load().then(() => {});
    }
  }
  public load(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.http
        .get(this.url + "env")
        .map((response: Response) => (response ? response.json() : null))
        .subscribe(
          (data) => {
            if (data.apiVersion) this.apiVersion = data.apiVersion;
            if (data.domain) this.domain = data.domain;
            this.apiVersion = environment.version;

            if (data.apiVersion) {
              const updateCache = JSON.parse(
                localStorage.getItem("updateCache")
              );

              if (
                updateCache == null ||
                updateCache.backendVersion != data.apiVersion ||
                updateCache.frontendVersion != environment.version ||
                updateCache.updating
              ) {
                this.frontendRefresh = true;
              }

              localStorage.setItem(
                "updateCache",
                JSON.stringify({
                  backendVersion: data.apiVersion,
                  frontendVersion: environment.version,
                  updating: this.frontendRefresh,
                })
              );
            }
            resolve(true);
          },
          (err) => {
            resolve(false);
          }
        );
    });
  }
  public isDevMode() {
    return isDevMode();
  }

  public versionCompare(device, v2) {
    const v =
      device.details && device.details.c3version
        ? device.details.c3version.split(" ")
        : [null];
    const v1 = v && v.length >= 2 && v[1] ? v[1] : v[0];
    console.log("v1", v1);

    const zeroExtend = true;
    let v1parts = v1.split(".");
    let v2parts = v2.split(".");

    function isValidPart(x) {
      return /^\d+$/.test(x);
    }

    if (!v1parts.every(isValidPart) || !v2parts.every(isValidPart)) {
      return NaN;
    }

    if (zeroExtend) {
      while (v1parts.length < v2parts.length) {
        v1parts.push("0");
      }
      while (v2parts.length < v1parts.length) {
        v2parts.push("0");
      }
    }

    v1parts = v1parts.map(Number);
    v2parts = v2parts.map(Number);

    for (let i = 0; i < v1parts.length; ++i) {
      if (v2parts.length == i) {
        return 1;
      }

      if (v1parts[i] == v2parts[i]) {
        continue;
      } else if (v1parts[i] > v2parts[i]) {
        return 1;
      } else {
        return -1;
      }
    }

    if (v1parts.length != v2parts.length) {
      return -1;
    }
    return 0;
  }
}

export function GlobalsFactory(config: Globals) {
  return () => config.load();
}
